import { Switch } from "@blueprintjs/core";
import { segmentTrackHideOutOfRegionBusesChanged } from "analytics/analyticTrackEvents";
import useMapViewConfiguration from "contexts/MapViewConfigurationContext/hooks/useMapViewConfiguration";
import FilterWrapper from "./FilterWrapper";

const OutOfRegionBusFilter: React.FC = () => {
    const {
        busFiltersConfiguration: {
            busFilters: { hideOutOfRegionBuses },
            toggleHideOutOfRegionBuses,
            filtersDisabled
        }
    } = useMapViewConfiguration();

    return (
        <FilterWrapper
            label={"Hide RTOE buses"}
            helperText='Toggle to "Yes" to hide buses that are now part of SPP through RTO Expansion (RTOE).'
            wideLabel={true}
        >
            <Switch
                checked={hideOutOfRegionBuses ?? false}
                onChange={(evt) => {
                    toggleHideOutOfRegionBuses();
                    segmentTrackHideOutOfRegionBusesChanged(evt.target.checked);
                }}
                innerLabel="No"
                innerLabelChecked="Yes"
                style={{ marginBottom: 0 }}
                alignIndicator="right"
                large={true}
                disabled={filtersDisabled}
            />
        </FilterWrapper>
    );
};

export default OutOfRegionBusFilter;
